import React from "react";
import PropTypes from "prop-types";
import { translate, Trans } from "react-i18next";
import logo from "../shared/logo.png";

const Header = ({ t,loginUrl }) => (
	<header className="d-flex py-2 px-4 bg-white align-items-center">
		<a
			href="https://www.velpic.com"
			target="_blank"
			rel="noopener noreferrer"
			className="mr-auto"
		>
			<img src={logo} alt={t("Velpic")} />
		</a>
		<Trans i18nKey="alreadyMemberLink">
			Already have an account? <a href={loginUrl}>Log in</a>
		</Trans>
	</header>
);

Header.propTypes = {
	t: PropTypes.func.isRequired,
};

export { Header };
export default translate()(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js